import { useEffect, useState } from 'react';
import VideoService from 'services/video/VideoService';
import TrendingNearYouSideBar from 'components/shared/TrendingNearYouSideBar';
import VideoCategorySkeleton from 'components/skeleton/VideoCategorySkeleton';

function VideoPageDiscover() {
  // const { id } = useParams();
  // console.log(id);
  const [genres, setGenres] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  //load data according to the id
  useEffect(() => {
    setLoading(true);
    // Was GenreService.getAllGenres() -> GET /genres, which filters
    // where('video', 0) and returns the MUSIC genres, not video ones. The
    // correct video-genre list (where('video', 1)) is VideoService's
    // /video/genres, already used correctly elsewhere (CategoriesCoursel).
    VideoService.getAllGenres()
      .then((res: any) => {
        setGenres(res?.genres ?? []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* main topic section */}
      <div className="mb-8">
        <h1 className="text-xl font-medium text-white lg:text-2xl md:text-3xl max-sm:w-[60%] max-sm:ml-2">
          Discover Movies and TV series
        </h1>
      </div>
      {/* coursel */}
      {loading ? (
        <VideoCategorySkeleton />
      ) : (
        genres.map((genre: any, i: number) => (
          <TrendingNearYouSideBar genre={genre} key={genre?.alt_name ?? i} />
        ))
      )}
    </div>
  );
}

export default VideoPageDiscover;
